import { CompanyAdminStatusPipe } from './company.admin-status.pipe';

export function CompanyAdminStatusFilter ( companyAdminStatusPipe : CompanyAdminStatusPipe ) {
  return ( value : string ) : string => companyAdminStatusPipe.transform(value);
};
